<template>
  <app-modal hide-title :title="title" width="80%" name="invoice-viewer-modal" :click-to-close="true"
    @before-open="beforeOpen" @before-close="beforeClose" :bodyClass="'pt-0'" :hide-footer-button="true">
    <div style="height: 79vh">
      <div v-if="invoiceListLoading" class="loading-container center">
        <div class="text-center">
          <h5>{{ $t('app.loading') }}</h5>
          <i class="fad fa-spinner-third fa-spin"></i>
        </div>
      </div>
      <invoice-viewer v-else-if="isPdfInvoice && !invoiceListLoading" :loading="invoiceListLoading"
        :src="invoiceBase64File"></invoice-viewer>
      <div v-else>
        <div class="d-flex ml-2 sticky-top bg-white pb-3" style="padding-top: 1.5rem;">
          <div class='flex-grow-1 invoice-viewer-modal-left'>
            <actions-button-menu :invoice="formModel" /> <!-- action btn -->
            <b-dropdown size="sm" offset="0" variant="link" toggle-class="text-decoration-none" no-caret
              :disabled="formModel && formModel.paid_date">
              <template #button-content>
                <div style="background-color: #E6F2FF" class="px-4 py-2 rounded"><i class="far fa-wallet"></i><span>{{
                  $t('invoice.pay') }}</span></div>
              </template>
              <div style="width: 300px;">
                <b-dropdown-form>
                  <invoice-pay-form v-if="formModel" :invoiceId="formModel.id"
                    :customer_or_vendor_id="formModel.customer_or_vendor_id"
                    @on-pay-invoice="date_str => formModel.paid_date = date_str"></invoice-pay-form>
                </b-dropdown-form>
              </div>
            </b-dropdown> <!-- add tag btn -->
            <b-dropdown size="sm" offset="0" variant="link" toggle-class="text-decoration-none" no-caret>
              <template #button-content>
                <div style="background-color: #E6F2FF" class="px-4 py-2 rounded"><i class="far fa-tags"></i>
                  <span>{{ $t('tag.tag') }}</span>
                </div>
              </template>
              <!-- <b-dropdown-item>
              </b-dropdown-item> -->
              <div style="width: 200px;">
                <app-search-box :placeholder="$t('directory.filter')" v-model="searchText">
                </app-search-box>
                <div class="context-menu__divider mt-2"></div>
                <b-dropdown-item @click="manageTag()">
                  <i class="fal fa-tag"></i>
                  {{ $t('tag.manageTag') }}
                </b-dropdown-item>
                <div class="context-menu__divider"></div>
                <b-dropdown-item @click="addTag()">
                  <i class="fal fa-plus"></i>
                  {{ $t('tag.createTag') }}
                </b-dropdown-item>
                <div class="context-menu__divider"></div>
                <b-dropdown-item
                  v-for="tag in tags.filter(tag => tag.name.toLowerCase().includes(searchText.toLowerCase()))"
                  :key="tag.id" @click="e => onClickTag(e, tag, formModel.id)">
                  <span :class="{ 'font-weight-bold': formModelTags[tag.id] ? true : false }"><i class="far fa-tag"
                      :style='{ color: tag.hex_color }'></i>
                    {{
                      tag.name
                    }}</span>
                </b-dropdown-item>
              </div>
            </b-dropdown>
            <!-- pay btn -->
            <!-- <div class="dropdown b-dropdown btn-group">
              <button class="btn btn-sm btn-link text-decoration-none rounded" @click="openReviewInvoice()">
                <div style="background-color: #E6F2FF; color: #FF7676" class="px-4 py-2">
                  <i class="fad fa-shield" aria-hidden="true"></i>
                  <span>Xem xét</span>
                </div>
              </button>
            </div> -->
          </div>
          <div class='flex-grow-1 invoice-viewer-modal-right'>
            <!-- :disabled="!hasProviderInfo && !formModel.secret_code && (!formModel.metadata || !formModel.metadata.signed_pdf)" -->
            <button class="btn btn-link btn-sm" @click="onViewInvoicePdf($event, formModel)">
              <i class="fa fa-file-pdf" aria-hidden="true"></i>
              {{ $t('upload.filePDF') }}
            </button>
            <button class="btn btn-link btn-sm" @click="onDownloadInvoice($event, formModel.id)"><i
                v-if="downloadInvoiceLoading" class="fad fa-spinner-third fa-spin mr-2"></i>
              <i v-else class="fa fa-download" aria-hidden="true" />
              {{ downloadInvoiceLoading ? $t('app.processing') : $t('report.downloadInvoice') }}</button>
          </div>
        </div>
        <!-- Mobile notice - separate row -->
        <div class="mobile-notice">
          * Để xem hóa đơn hoàn thiện và đầy đủ thông tin hãy sử dụng Máy tính.
        </div>

        <!-- Mobile zoom controls -->
        <div class="zoom-controls" v-if="isMobile">
          <button @click="zoomOut" :disabled="currentZoom <= 0.5">
            <i class="fas fa-search-minus"></i>
          </button>
          <span class="zoom-level">{{ Math.round(currentZoom * 100) }}%</span>
          <button @click="zoomIn" :disabled="currentZoom >= 2">
            <i class="fas fa-search-plus"></i>
          </button>
          <button @click="resetZoom">
            <i class="fas fa-expand-arrows-alt"></i>
          </button>
        </div>

        <div class="invoice-container" :style="{ transform: `scale(${currentZoom})`, transformOrigin: 'top left' }">
          <invoice-form-viewer ref="form" :form-model="formModel" @on-verify-invoice="onVerifyInvoice"
            v-show="!isPdfInvoice && !invoiceListLoading"></invoice-form-viewer>
        </div>
      </div>
    </div>
    <template v-show="invoiceList.length" v-slot:control>
      <div class="w-60" style="max-width: 80%; overflow: hidden;">
        <span>Thẻ: </span>
        <label class="badge">
          <span v-if="formModel.releasing_status" :class="`bg-${formModel.releasing_status}`">{{
            $t(`invoice.releasingStatus.${formModel.releasing_status}`) }}</span>
          <span v-else-if="formModel.paid_date" class="bg-tint-4">{{ $t('invoice.paid') }}: {{ formModel.paid_date |
            formatDate }}</span>
          <span v-else class="bg-error">{{ $t('invoice.unpaid') }}</span>
        </label>
        <label v-if="Object.entries(formModelTags).length > 0"
          v-for="[tagId, { name, hex_color }] in Object.entries(formModelTags)" class="badge" :key="tagId">
          <span :style="{ backgroundColor: hex_color }">
            {{ name }}
          </span>
        </label>
      </div>
      <div class="w-40" v-if="isPagination">
        <button :disabled="invoiceListLoading" @click="onClickPrev" class="btn btn-outline-secondary btn-sm">
          <i class="fal fa-chevron-left"></i>
        </button>
        <span v-if="!downloadInvoiceLoading"> {{ renderIndex }} / {{ invoiceListPageInfo.total }}</span>
        <span v-else>loading</span>
        <button :disabled="invoiceListLoading" @click="onClickNext" class="btn btn-outline-secondary btn-sm mr-auto">
          <i class="fal fa-chevron-right"></i>
        </button>
      </div>
    </template>
  </app-modal>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import AppModal from '@/components/app-modal/';
import InvoiceViewer from '@/portal-components/invoice/invoice-viewer';
import InvoiceFormViewer from '@/portal-components/invoice/invoice-form-viewer';
import AccountProxy from '@/store/proxies/account-proxy';
import { downloadFile, getFilenameFromResponse } from '@/utils/download';
import ToastUtils from '@/utils/toast';
import { EInvoiceProxy } from '@/store/proxies/e-invoice';
import { buildActionInvoiceItem } from '@/utils/invoice';
import { INVOICE_ACTIONS } from '@/app-constant';
import CheckPermissionMixin from '@/mixins/check-permission';
import onPreviewInvoice from '@/utils/invoice-preview';
import ActionsButtonMenu from '@/portal-components/invoice/actions-menu/actions-button-menu';
import AppSearchBox from '@/components/app-search-box';
import InvoicePayForm from '@/portal-components/invoice-pay-form';
import { PROVIDER_INFORMATION } from '@/app-constant';

export default {
  name: 'InvoiceViewerModal',
  components: {
    InvoiceFormViewer,
    AppModal,
    InvoiceViewer,
    ActionsButtonMenu,
    AppSearchBox,
    InvoicePayForm
  },
  mixins: [CheckPermissionMixin],
  data() {
    return {
      title: '',
      status: '',
      formModel: null,
      currentIndex: 0,
      isPagination: false,
      formModelTags: {},
      okText: '',
      keyword: {
        expired: 'hết hạn',
        tax_authority: 'Cơ Quan Thuế',
        status_401: '401',
        status_500: '500',
      },
      searchText: '',
      // Mobile zoom functionality
      currentZoom: 1.0,
      isMobile: false
    };
  },
  computed: {
    ...mapGetters(['isPdfInvoice']),
    ...mapState([
      'invoiceBase64File',
      'invoiceFileLoading',
      'downloadInvoiceLoading',
      'invoiceList',
      'invoiceListLoading',
      'invoiceListPageInfo',
      'tags'
    ]),
    renderIndex() {
      const {
        current_page: currentPage,
        current_limit: currentLimit,
      } = this.invoiceListPageInfo;
      if (this.isPagination) {
        return ((currentPage - 1) * currentLimit) + this.currentIndex + 1;
      }
      return this.currentIndex + 1;
    },
    hasProviderInfo() {
      if (!this.formModel.tcgp_taxcode) {
        return false;
      }
      else return !!PROVIDER_INFORMATION.find(company => company.taxCode === this.formModel.tcgp_taxcode);
    }
  },
  methods: {
    ...mapActions(['loadInvoiceFile', 'checkValidCustomer', 'downloadInvoice', 'setTag']),
    extractMetadataObjects(model = {}) {
      if (!model || !model.metadata) return { ...model };

      const meta = model.metadata;
      return {
        ...model,
        ...meta.buyer_obj,
        buyer_obj: meta.buyer_obj || model.buyer_obj || {},
        ...meta.seller_obj,
        seller_obj: meta.seller_obj || model.seller_obj || {},
      };
    },
    beforeOpen(params) {
      this.formModel = this.extractMetadataObjects(params.model);

      this.currentIndex = params.currentIndex;
      this.isPagination = Boolean(params.isPagination);
      this.status = params.model.releasing_status;

      this.formModelTags = (params.model.tags || []).reduce((acc, tag) => {
        if (!acc[tag.id]) {
          acc[tag.id] = {
            name: tag.name,
            hex_color: tag.hex_color || '#CCCCCC'
          };
        }
        return acc;
      }, {});
    },
    beforeClose() {
      this.title = '';
      this.formModel = null;
      this.currentIndex = 0;
      this.isPagination = false;
      this.okText = '';
      this.formModelTags = {};
    },
    loadFormModel(index = this.currentIndex) {
      const ctx = this;
      if (index < 0 || index === null || index === undefined) {
        this.currentIndex = this.invoiceList.findIndex(
          (invoice) => this.formModel && this.formModel.id === invoice.id
        );
        return;
      }

      const clampedIndex = Math.max(0, Math.min(index, this.invoiceList.length - 1));
      this.currentIndex = clampedIndex;

      const rawModel = this.invoiceList[clampedIndex];
      this.formModel = this.extractMetadataObjects({ ...rawModel });

      this.formModelTags = (this.formModel.tags || []).reduce((acc, tag) => {
        if (!acc[tag.id]) {
          const getMoreTagInfo = ctx.tags.find(({ id }) => id === tag.id);
          acc[tag.id] = {
            name: tag.name,
            hex_color: getMoreTagInfo ? getMoreTagInfo.hex_color : '#CCCCCC'
          };
        }
        return acc;
      }, {});

      this.okText = this.formModel.origin === '4' ? '' : this.$t('reconciliation.reconciliation');
      if (this.status) {
        if (['draf', 'release_error'].includes(this.status)) {
          this.okText = this.$t('invoice.issueTheInvoice');
        } else {
          this.okText = '';
        }
      }
    },
    confirmInvoices(invoiceIds) {
      this.$modal.show('dialog', {
        title: this.$t('reconciliation.invoiceReconciliation'),
        text: this.$t('app.confirmValidInvoice'),
        okText: this.$t('app.confirm'),
        okClass: 'btn btn-primary btn-sm',
        showLoading: true,
        onOk: async () => {
          new AccountProxy().confirmInvoices(invoiceIds).then((res) => {
            // this.okText = '';
            this.$bus.emit('on-confirm-invoice-success', res);
          });
        },
      });
    },
    onIssueInvoice() {
      new EInvoiceProxy().getEInvoice(this.formModel.id_pinvoice)
        .then((res) => {
          if (!res) return;
          const actionKey = INVOICE_ACTIONS.ISSUE_INVOICE;
          const props = {
            option: {
              key: actionKey,
              name: this.$t(`actions.options.${actionKey}`),
              title: this.$t(`actions.title.${actionKey}`),
            },
            item: {
              ...this.formModel,
              ...(res.buyer_obj || {}),
              ...buildActionInvoiceItem(res),
            },
          };
          const modalName = this.determineModalName('actions-invoice-modal');
          this.$modal.show(modalName, props);
        })
        .catch((error) => {
          ToastUtils.showToast('error', error.message || error);
        });
    },
    // onOk() {
    //   if (this.status) {
    //     if (['draf', 'release_error'].includes(this.status)) {
    //       this.onIssueInvoice();
    //     }
    //   } else { this.confirmInvoices([this.formModel.id]); }
    // },
    onClickNext() {
      const {
        total,
        current_page: currentPage,
        current_limit: currentLimit,
      } = this.invoiceListPageInfo;

      if (this.currentIndex < this.invoiceList.length - 1) {
        this.loadFormModel(this.currentIndex + 1);
      } else if (currentPage * currentLimit < total) {
        if (this.isPagination) {
          const query = { ...this.$route.query, page: currentPage + 1 };
          this.$router.push({ name: this.$route.name, params: this.$route.params, query });
          this.currentIndex = 0;
        } else {
          const pagingInfo = { ...this.invoiceListPageInfo, page: currentPage };
          this.$bus.emit('invoice-viewer-load-more', pagingInfo);
          this.currentIndex++;
        }
      }
    },

    onClickPrev() {
      const {
        current_page: currentPage,
        current_limit: currentLimit,
      } = this.invoiceListPageInfo;

      if (this.currentIndex > 0) {
        this.loadFormModel(this.currentIndex - 1);
      } else if (currentPage > 1 && this.isPagination) {
        const query = { ...this.$route.query, page: currentPage - 1 };
        this.$router.push({ name: this.$route.name, params: this.$route.params, query });
        this.currentIndex = currentLimit - 1;
      }
    },
    async onVerifyInvoice(invoice) {
      const { id } = invoice;
      this.checkValidCustomer(id)
        .then((res) => {
          this.formModel.customer_invalid_data = res;
          const data = {
            ...invoice,
            customerInvalidData: res,
          };
          this.$bus.emit('verify-invoice-success', data);
        })
        .catch(() => {
          this.$bus.emit('verify-invoice-success');
        });
    },
    onDownloadInvoice($event, invoiceID) {
      $event.preventDefault();
      $event.stopPropagation();

      const payload = { id: invoiceID, return_xml: true };
      this.downloadInvoice(payload)
        .then((res) => {
          if (res && res.data) {
            downloadFile(
              getFilenameFromResponse(res),
              res.data,
              { type: 'application/zip' },
            );
          }
        })
        .catch((e) => {
          if (e.status_code === 400) {
            if (e.message.includes(this.keyword.expired) || e.message.includes(this.keyword.status_401)) {
              this.$modal.show('tax-account-connect-modal', { model: { isUpdatePassword: false } });
            } else if (e.message.includes(this.keyword.tax_authority) || e.message.include(this.keyword.status_500)) {
              ToastUtils.showToast('error', this.$t('invoice.viewContent.error.500'));
            }
            ToastUtils.showToast('error', this.$t('invoice.viewContent.error.500'));
          } else {
            ToastUtils.showToast('error', this.$t('invoice.viewContent.error.connection'));
          }
        });
    },
    onViewInvoicePdf($event, formModel) {
      const invoice = formModel;
      const { id_pinvoice, tcgp_taxcode, secret_code } = invoice;
      if (id_pinvoice) {
        return onPreviewInvoice.bind(this)($event, invoice);
      }
      // if (!tcgp_taxcode || !secret_code) {
      //   ToastUtils.showToast('error', this.$t('invoice.external-invoice.dataNotAvailable'));
      //   return;
      // }

      this.$modal.show('external-invoice-modal', {
        model: {
          taxCode: tcgp_taxcode,
          secretCode: secret_code,
        },
      });
    },
    addTag() {
      this.$modal.show('tag-modal', { model: { name: this.searchText } });
    },
    manageTag() {
      this.$modal.show('manage-tag-modal', { model: {} });
    },
    onClickTag(e, tag, invoiceId) {
      if (this.formModelTags[tag.id]) {
        delete this.formModelTags[tag.id];
      } else {
        // const tagInfo = this.tags.find(({ id }) => id === tag.id)
        this.formModelTags[tag.id] = tag;
      }
      this.setTag({
        tags: [...Object.keys(this.formModelTags)],
        invoices: [invoiceId]
      }).then(() => {
        this.$bus.emit('on-select-tags', Object.values(this.formModelTags), invoiceId);
      })

      this.formModelTags = { ...this.formModelTags };
    },
    openReviewInvoice() {
      this.$modal.show('invoice-review-modal', { model: { invoicesId: [this.formModel.id] } });
    },
    // Mobile zoom methods
    checkMobile() {
      this.isMobile = window.innerWidth <= 768;
    },
    zoomIn() {
      if (this.currentZoom < 2) {
        this.currentZoom = Math.min(2, this.currentZoom + 0.2);
      }
    },
    zoomOut() {
      if (this.currentZoom > 0.5) {
        this.currentZoom = Math.max(0.5, this.currentZoom - 0.2);
      }
    },
    resetZoom() {
      this.currentZoom = 1.0;
    }
  },
  mounted() {
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile);
  },
  watch: {
    invoiceListLoading(newValue) {
      if (!newValue) {
        this.loadFormModel();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.invoice-viewer-modal-left {
  display: flex;
  justify-content: flex-start;
}

.invoice-viewer-modal-right {
  display: flex;
  justify-content: flex-end;
}

// Mobile zoom controls
.zoom-controls {
  position: fixed;
  top: 10px;
  right: 10px;
  z-index: 1000;
  display: flex;
  gap: 5px;
  background: rgba(255, 255, 255, 0.95);
  padding: 8px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);
  border: 1px solid #ddd;

  button {
    padding: 6px 10px;
    font-size: 0.7rem;
    border: 1px solid #ddd;
    background: white;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover:not(:disabled) {
      background: #f5f5f5;
      border-color: #0078d4;
    }

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }

    i {
      font-size: 0.8rem;
    }
  }

  .zoom-level {
    padding: 6px 8px;
    font-size: 0.7rem;
    font-weight: 600;
    color: #333;
    min-width: 40px;
    text-align: center;
    background: #f8f9fa;
    border-radius: 4px;
    border: 1px solid #e9ecef;
  }
}

// Invoice container for zoom
.invoice-container {
  transition: transform 0.3s ease;
  transform-origin: top left;
}

// Mobile responsive adjustments
@media screen and (max-width: 768px) {
  .zoom-controls {
    top: 5px;
    right: 5px;
    padding: 6px;
    gap: 4px;

    button {
      padding: 4px 8px;
      font-size: 0.65rem;
    }

    .zoom-level {
      padding: 4px 6px;
      font-size: 0.65rem;
      min-width: 35px;
    }
  }
}

@media screen and (max-width: 480px) {
  .zoom-controls {
    top: 3px;
    right: 3px;
    padding: 4px;
    gap: 3px;

    button {
      padding: 3px 6px;
      font-size: 0.6rem;
    }

    .zoom-level {
      padding: 3px 5px;
      font-size: 0.6rem;
      min-width: 30px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/portal-components/invoice/invoice-viewer-modal.vue